module.exports = __webpack_public_path__ + "img/IMG_9519_L_Wood.c8b3dc09.jpg";